import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useSuperAdminAuth } from '@/contexts/SuperAdminAuthContext';

export function SuperAdminRoute({ children }: { children: ReactNode }) {
  const { isAuthenticated, isLoading } = useSuperAdminAuth();
  if (isLoading) return null;
  if (!isAuthenticated) return <Navigate to="/super-admin/login" replace />;
  return <>{children}</>;
}
